/* eslint-disable no-nested-ternary */
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Menu,
  Segment,
  Table,
} from 'semantic-ui-react';
import qs from 'qs';
import { required, matchRegex, phoneNumber, identity as ValidateIdentity } from '@mhub/web-validations';
import moment from 'moment-timezone';
import clone from 'clone';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { flashSuccessMessage, flashErrorMessage, flashMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import {
  DEVELOPER_EXECUTIVE,
  DEVELOPER_BRANCH_LEADER,
  DEVELOPER_HEADQUARTERS,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  GROUP_ID_ANALYTICS,
  ANALYTICS,
  devGroups,
  ignoreGroupIDs,
  creditControlGroups,
  commissionTrackerGroups,
  COMMISSION_TRACKER_TEAM_LEADER,
  COMMISSION_TRACKER_AGENT,
} from '../../constants/groups';
import { roleOptions } from '../../constants/roles';
import NavBar from '../../components/NavBar';
import EditableBox from '../../components/EditableBox';
import AppForm from '../../components/AppForm';
import PhoneInput from '../../components/AppForm/PhoneInput';
import Select from '../../components/AppForm/Select';
import Phone from '../../components/Phone';
import ListItem from '../../components/ListItem';
import ProjectsList from '../modals/ProjectsList';
import DeleteConfirm from '../../containers/modals/DeleteConfirm';
import MoveStaffToExternalBranch from '../../containers/modals/MoveStaffToExternalBranch';
import SpecificationTable from '../../components/SpecificationTable';
import Timestamp from '../../components/Timestamp';
import { displayMoment } from '../../utils/displayTime';
import { isCountryVietnam } from '../../constants/countries';
import { routes } from './navigations';
import { getPhoneValidRegex } from '../../utils/validations/phone';
import { getItem } from '../../utils/storage';
import { withUserGroups } from '../../utils/staff';
import TinFieldInput from '../../components/AppForm/TinFieldInput';
import { REGEX_TIN_VALID, REGEX_NPWP_ID, REGEX_FULL_NAME, REGEX_BANK_ACCOUNT_NUMBER } from '../../constants/regex';
import { getIdentityTypeOpts } from '../../utils/identityTypes';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { translateModels } from '../../utils/translation';
import SelectBank from '../../components/AppForm/SelectBank';
import { GENERIC_TIN_UNMATCHED_ERROR_MSG, GENERIC_TIN_VALUES, getGenericTinByIdTypeAndTinNo, GOVERNMENT_GENERIC_TIN, isGenericTinFound } from '../../constants/tin';
import { IDENTITY_TYPE_NRIC } from '../../constants/defaultIdentityTypeOpts';
import i18n from '../../i18n';

const styles = {
  divider: { margin: '0.5em 0' },
};

// These audit rows name their zone with `z`. Once a Vietnam value is converted to the viewer's
// browser zone that token resolves to an empty string, which would silently drop the zone from a
// row whose whole point is when a ban started and ends — so Vietnam spells the offset out instead.
const cooldownFormat = countryCode => (isCountryVietnam(countryCode)
  ? 'MMMM Do YYYY, h:mm:ss a ([UTC]Z)'
  : 'MMMM Do YYYY, h:mm:ss a (z)');

class Overview extends Component {

  static contextTypes = {
    store: PropTypes.object,
  }

  static propTypes = {
    auth: PropTypes.shape({
      email: PropTypes.string,
      isBranchLeaderSupervisor: PropTypes.bool,
      isMainHeadquarters: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    routeParams: PropTypes.shape({
      id: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }

  static mapStateToProps = state => ({
    auth: state.auth,
  })

  constructor(props) {
    super(props);
    const tinError = null;

    let phoneValidationPresets = {};
    const storePhoneValidationPresets = getItem(`${config.get('appName')}.phoneValidationPresets`);
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    this.state = {
      token: null,
      loading: true,
      edit: false,
      data: null,
      oriData: null,
      branches: [],
      fullBranches: [],
      errMessages: [],
      tinMessage: null,
      hasChanges: false,
      showConfirmBranch: false,
      selectedBranchIsExternal: false,
      showAddProject: false,
      cooldownToken: null,
      cooldownBAPData: [],
      cooldownData: [],
      deleteCooldownType: '', // 'bap' or 'unit'
      deleteCooldownName: '',
      deleteCooldownID: '',
      showDeleteCooldownConfirm: false,
      phoneValidationPresets,
      tinError,
      tinRequired: false,
      tinEnabled: true,
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false,
    };
    this.validation = {
      name: createRef(),
      preferredName: createRef(),
      email: createRef(),
      mobilePrefix: createRef(),
      mobile: createRef(),
      companyBranchID: createRef(),
      role: createRef(),
      identityNo: createRef(),
      taxIdentificationNo: createRef(),
      fullName: createRef(),
      bankAccountName: createRef(),
      bankAccountNumber: createRef(),
    };
  }
  componentDidMount() {
    // Set moment locale based on current language
    const languageMap = {
      en: 'en-gb',
      vi: 'vi',
      id: 'id',
    };
    moment.locale(languageMap[i18n.language] || 'en-gb');
    // Listen for language changes
    i18n.on('languageChanged', this.handleLanguageChange);

    const { store } = this.context;
    this.setLoading(true)
      .then(() => {
        const promises = [
          this.fetchStaff(),
        ];
        if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
          promises.push(this.fetchCompanyBranches());
          promises.push(this.fetchStaffCooldowns('bap'));
          promises.push(this.fetchStaffCooldowns('unit'));
        }
        return Promise.all(promises)
          .catch((err) => {
            Bugsnag.notifyException(err);
            store.dispatch(flashErrorMessage(err));
          });
      })
      .then(() => this.setLoading(false));
  }
  getRoles = () => {
    const rolesArr = [];
    if (this.state.data.user.groups && this.state.data.user.groups.length > 0) {
      this.state.data.user.groups.forEach((g) => {
        // ignore CC & analytics role in SR
        if (ignoreGroupIDs.includes(g.id)) return;
        rolesArr.push(g.id);
      });
    }
    rolesArr.sort();
    return String(rolesArr.toString());
  }
  getRoleText = (roles) => {
    const role = roles.find(g => g.value === this.getRoles());
    if (role && role.text) {
      return role.text;
    }
    return '';
  }
  getBranchProjects = () => {
    const { data, fullBranches } = this.state;
    if (data && data.companyBranchID && fullBranches.length > 0) {
      const foundBranch = fullBranches.find(d => d.id.toString() === data.companyBranchID);
      if (foundBranch && foundBranch.projects && foundBranch.projects.length > 0) {
        return foundBranch.projects.filter(d => d.statusID !== 'deleted');
      }
    }
    return [];
  }
  getBranchViewAllProjects = () => {
    const { data, fullBranches } = this.state;
    if (data && data.companyBranchID) {
      const foundBranch = fullBranches.find(d => d.id.toString() === data.companyBranchID);
      if (foundBranch && foundBranch.viewAllProjects) {
        return true;
      }
    }
    return false;
  }
  componentDidUpdate(prevProps, prevState) {
    // Sync moment locale when language changes
    if (prevProps && prevProps.i18n && prevProps.i18n.language !== this.props.i18n.language) {
      const languageMap = {
        en: 'en-gb',
        vi: 'vi',
        id: 'id',
      };
      moment.locale(languageMap[this.props.i18n.language] || 'en-gb');
      this.forceUpdate();
    }
    if (prevState.data !== this.state.data) {
      this.updateTinFieldState();
    }
  }
  componentWillUnmount() {
    // Clean up language change listener
    i18n.off('languageChanged', this.handleLanguageChange);
  }
  handleLanguageChange = () => {
    const languageMap = {
      en: 'en-gb',
      vi: 'vi',
      id: 'id',
    };
    moment.locale(languageMap[i18n.language] || 'en-gb');
    this.forceUpdate();
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setLoading = (loading = false, loadingType = '') => new Promise((res) => {
    if (loadingType === 'validatingTIN') {
      this.setState({ validatingTin: loading }, res);
    } else {
      this.setState({ loading }, res);
    }
  })
  updateTinFieldState = () => {
    const { data } = this.state;
    let tinError = true;
    if (data && data.taxTinValidationStatus === 'success') {
      tinError = false;
    }
    if (this.state.tinError !== tinError) {
      this.setState({ tinError });
    }
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        this.handleOnCheck(true);
      });
    }
  }
  handleResetCheck() {
    if (this.state.hasChanges) {
      this.setState({ hasChanges: false }, () => {
        this.handleOnCheck(false);
      });
    }
  }
  async validateTIN(tinInput) {
    const { data } = this.state;
    if (!tinInput || !data.identityNo) {
      return;
    }
    const idType = getIdentityTypeOpts().find(i => i.value === IDENTITY_TYPE_NRIC).tin_code;
    const query = Object.assign({
      tin: tinInput,
      idType,
      idValue: data.identityNo,
    });
    const { store } = this.context;
    try {
      const res = await store.dispatch(fetchM(`/tin/validate/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
          'X-Origin': this.state.origin,
        },
      }));

      if (res && res.ok) {
        this.setState({
          tinError: false,
          tinFound: true,
          tinMessage: null,
        });
      } else {
        const errorMessage = await res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
        return;
      }
    } catch (err) {
      if (err.res) {
        const errorMessage = await err.res.text();
        this.setState({
          tinError: true,
          tinFound: false,
          tinMessage: errorMessage,
        });
      }
    }
  }
  handleTinInput = (e) => {
    const { data, tinMessage } = this.state;
    const tinInput = e.target.value;
    const tinFound = e.target.tinFound;
    const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    const isIndonesia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      data.taxIdentificationNo = e.target.value;
      this.setState({ data }, () => {
        this.handleCheckChanges();
      });
      return;
    }

    if (tinInput === '') {
      data.taxIdentificationNo = '';
      this.setState({ data, tinFound: false, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      data.taxIdentificationNo = tinInput;
      this.setState({ data, tinFound, tinError: tinFound === false, tinMessage: this.state.tinMessage }, () => {
        this.handleCheckChanges();
      });

      if (tinFound) {
        return;
      }

      const matched = REGEX_TIN_VALID.test(tinInput);
      const genericTin = getGenericTinByIdTypeAndTinNo(IDENTITY_TYPE_NRIC, tinInput);
      this.setLoading(true, 'validatingTIN').then(() => {
        if (this.debounceTimeout) {
          clearTimeout(this.debounceTimeout);
        }

        this.debounceTimeout = setTimeout(() => {
          if (matched) {
            if (tinInput === GOVERNMENT_GENERIC_TIN) {
              this.setState({
                tinError: false,
                tinFound: true,
                tinMessage: null },
              () => {
                this.setLoading(false, 'validatingTIN');
              });
            } else if (GENERIC_TIN_VALUES.includes(tinInput)) {
              this.setState({
                tinError: !isGenericTinFound(genericTin),
                tinFound: isGenericTinFound(genericTin),
                tinMessage: !isGenericTinFound(genericTin) ? GENERIC_TIN_UNMATCHED_ERROR_MSG : null },
              () => {
                this.setLoading(false, 'validatingTIN');
              });
            } else {
              this.validateTIN(tinInput).finally(() => {
                this.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            this.setState({ tinError: true }, () => {
              this.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  };
  handleOnChange = (event, value) => {
    const { data, fullBranches } = this.state;
    let selectedBranchIsExternal = this.state.selectedBranchIsExternal;
    if (value.name === 'companyBranchID') {
      const branch = fullBranches.find(b => b.id.toString() === value.value);
      if (branch) {
        selectedBranchIsExternal = branch.isExternal;
        data.user.groups = data.user.groups.filter(g => (g.code === DEVELOPER_EXECUTIVE));
      }
    }
    data[value.name] = value.value;
    this.setState({ data, selectedBranchIsExternal }, () => {
      this.handleCheckChanges();
    });
  }
  handleUserOnChange = (event, value) => {
    const { data } = this.state;
    data.user[value.name] = value.value;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleCheckBoxChange = (event, value) => {
    const { data } = this.state;
    if (value.name === 'viewAnalyticsDashboard') {
      if (value.checked) {
        if (data.user && (!data.user.groups || (data.user.groups && data.user.groups.findIndex(g => g.id === GROUP_ID_ANALYTICS) === -1))) {
          const groups = [...data.user.groups, ...[{ id: GROUP_ID_ANALYTICS, code: ANALYTICS }]];
          data.user.groups = groups;
        }
      } else if (data.user && data.user.groups) {
        data.user.groups = data.user.groups.filter(g => g.id !== GROUP_ID_ANALYTICS);
      }
    } else {
      data[value.name] = value.checked;
    }
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleAccessCheckBoxChange = (event, value) => {
    const { data } = this.state;
    data.access[value.name] = value.checked;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleUserCheckBoxChange = (event, value) => {
    const { data } = this.state;
    data.user[value.name] = value.checked;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleEditStaff = () => {
    this.setState({ edit: true });
  }
  handleUpdateStaff = () => {
    const { data, fullBranches } = this.state;
    const newBranch = fullBranches.find(b => b.id === parseInt(data.companyBranchID, 10));
    const hasHigherAccess = data.user.groups.find(
      g => g.code === DEVELOPER_HEADQUARTERS || g.code === DEVELOPER_BRANCH_LEADER,
    );
    if (this.props.auth.isHeadquarters) {
      if (!(data.companyBranch && data.companyBranch.isExternal) && newBranch && newBranch.isExternal && hasHigherAccess) {
        this.setState({ showConfirmBranch: true });
      } else {
        this.updateStaff(data);
      }
    } else {
      this.updateStaff(data);
    }
  }
  handleCancelChange = (e) => {
    e.preventDefault();
    this.setState({
      showConfirmBranch: false,
    });
  }
  handleConfirmChange = (e) => {
    e.preventDefault();
    this.setState({
      showConfirmBranch: false,
    }, () => {
      const { data } = this.state;
      this.updateStaff(data);
    });
  }
  handleResetChanges = () => {
    const { oriData } = this.state;
    this.setState({
      data: clone(oriData),
      edit: false,
    }, () => {
      this.handleResetCheck();
    });
  }
  handleGroupChange = (event, d, groupOpts) => {
    const { data } = this.state;
    const groups = groupOpts.filter(g => (
      g.code === d.value
    ));
    const group = Object.assign(...groups.map(g => ({ id: g.id, code: g.code })));
    const index = data.user.groups.findIndex(g => g.id === group.id);
    if (d.checked && index < 0) {
      data.user.groups.push(group);
    }
    if (!d.checked && index > -1) {
      data.user.groups.splice(index, 1);
    }
    this.setState({ data });
  }
  handleChangeRole = (e, d) => {
    const { data } = this.state;
    const groupIDs = d.value.split(',');
    let groups = devGroups.filter(g => groupIDs.includes(g.id));

    const untouchedGroups = data.user.groups.filter(g => ignoreGroupIDs.includes(g.id));
    if (untouchedGroups && untouchedGroups.length > 0) {
      groups = [...groups, ...untouchedGroups];
    }

    data.user.groups = groups;
    this.setState({ data });
  }
  handleRemoveProject = (index) => {
    if (this.state.edit) {
      const { data } = this.state;
      data.projects.splice(index, 1);
      this.setState({ data });
    }
  }
  handleAddProject = (e, projects) => {
    e.preventDefault();
    const { data } = this.state;
    data.projects = projects;
    this.setState({
      data,
      showAddProject: false,
    });
  }
  handleShowAddProject = (e) => {
    e.preventDefault();
    this.setState({
      showAddProject: true,
    });
  }
  handleCloseAddProject = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAddProject: false,
    });
  }
  handleMappingChange = (m) => {
    const { data } = this.state;
    data.mappings = m;
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('bookApiURL')) || value.includes(config.get('salesChartURL'))) {
      e.preventDefault();
      const winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleDeleteCooldownOpen = (e, id, name, type) => {
    e.preventDefault();
    this.setState({
      deleteCooldownType: type,
      deleteCooldownName: name,
      deleteCooldownID: id,
      showDeleteCooldownConfirm: true,
    });
  }
  handleCancelDeleteCooldown = (e) => {
    e.preventDefault();
    this.setState({
      deleteCooldownName: '',
      deleteCooldownID: '',
      showDeleteCooldownConfirm: false,
    });
  }
  handleConfirmDeleteCooldown = (e) => {
    e.preventDefault();
    this.setState({ showDeleteCooldownConfirm: false }, () => {
      this.deleteStaffCooldowns();
    });
  }
  staffIsAgent() {
    const staff = this.state.data;
    if (staff && staff.companyBranch && staff.companyBranch.isExternal) {
      return true;
    }
    return false;
  }
  updateStaff(data) {
    const { t } = this.props;
    const newData = { ...data };
    if (newData && newData.mappings) {
      const m = newData.mappings.filter(d =>
        d.name.length > 0 && d.value.length > 0).map((d, idx) => ({
          ...d,
          position: idx + 1,
        }));
      newData.mappings = m;
    } else {
      newData.mappings = [];
    }
    // `role` is derived from user.groups rather than being a field on the staff
    // record, so hand the validator a synthetic value instead of polluting the
    // payload that gets PUT.
    return AppForm.validate(this.validation, { ...newData, role: this.getRoles() })
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });

        const updatedData = {
          ...newData,
          taxTinValidationStatus: this.state.tinError === false ? 'success' : 'failed',
        };

        if (this.state.errMessages.length === 0 && this.state.tinRequired && updatedData.taxTinValidationStatus !== 'success') {
          const { store } = this.context;
          store.dispatch(flashMessage({
            header: t('Invalid TIN', { ns: TRANSLATION_FILES.translation }),
            message: t('Tax Identification Number is invalid', { ns: TRANSLATION_FILES.translation }),
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000,
          }));
          return;
        }
        this.putStaff(validations, updatedData)
        .catch((err) => {
          Bugsnag.notifyException(err);
        });
      });
  }
  async fetchStaff() {
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/staffs/${this.props.routeParams.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = withUserGroups(await res.json());
      if (!data.access) {
        data.access = {
          allowEditUnitPrice: true,
          allowEditUnitDetails: true,
        };
      }
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
        oriData: clone(data),
        selectedBranchIsExternal: data.companyBranch ? data.companyBranch.isExternal : false,
      }, () => {
        this.handleResetCheck();
      });
    }
  }
  async putStaff(validations, staff) {
    const { t } = this.props;
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);

    if (errors.length > 0) {
      this.setState({ edit: true });
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    await this.setLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/staffs/${this.props.routeParams.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(staff),
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const data = withUserGroups(await res.json());
    await this.setComponentState({
      edit: false,
      data,
      loading: false,
      oriData: clone(data),
    }, () => {
      this.handleResetCheck();
      this.fetchCompanyBranches();
    });
    store.dispatch(flashSuccessMessage({ header: t('Update Success', { ns: TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: TRANSLATION_FILES.translation, name: data.name }) }));
  }
  async fetchCompanyBranches() {
    const { t } = this.props;
    const { store } = this.context;
    let res;

    const query = {
      page: 'all',
      getProjects: true,
      statusFilter: 'active',
    };
    const queryString = qs.stringify(query);

    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/?${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const branches = await res.json();
      await this.setState({
        branches: branches ? branches.map((ul) => {
          const branch = { text: ul.name, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
          return branch;
        }) : [],
        fullBranches: branches,
      });
    }
  }
  async fetchStaffCooldowns(type) {
    const { t } = this.props;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/staffs/${this.props.routeParams.id}/cooldowns/?type=${type}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      let { cooldownBAPData, cooldownData } = this.state;
      if (type === 'bap') {
        cooldownBAPData = data;
      } else {
        cooldownData = data;
      }
      await this.setComponentState({
        cooldownToken: token,
        cooldownBAPData,
        cooldownData,
      });
    }
  }
  async deleteStaffCooldowns() {
    const { t } = this.props;
    const { store } = this.context;
    const { deleteCooldownType, deleteCooldownName, deleteCooldownID } = this.state;
    if (!(deleteCooldownID || deleteCooldownName)) {
      return;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/staffs/${this.props.routeParams.id}/cooldowns/${deleteCooldownID}/?type=${deleteCooldownType}`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.cooldownToken,
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      const { t } = this.props;
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({ header: t('Delete Success', { ns: TRANSLATION_FILES.translation }), message: t('{{type}} for {{name}} was successfully deleted.', { ns: TRANSLATION_FILES.translation, type: this.state.deleteCooldownType === 'bap' ? t('Entry', { ns: TRANSLATION_FILES.translation }) : t('Cooldown', { ns: TRANSLATION_FILES.translation }), name: deleteCooldownName }) }));
      await this.setComponentState({
        deleteCooldownName: '',
        deleteCooldownID: '',
        deleteCooldownType: '',
      }, () => {
        this.fetchStaffCooldowns(deleteCooldownType);
      });
    }
  }
  accessStatus(statusID) {
    const { t } = this.props;
    const status = this.userStateses.filter(s => (
      s.value === statusID
    ));
    const v = Object.assign(...status.map(s => ({ value: s.value, text: s.text })));
    return t(v.text, { ns: TRANSLATION_FILES.constants });
  }
  isUserType(groupID) {
    if (this.state.data.user.groups) {
      return this.state.data.user.groups.some(group => (
        group.id === groupID
      ));
    }
    return false;
  }
  isEditStaffHeadquarters() {
    if (this.state.data.user.groups) {
      return this.state.data.user.groups.some(group => (group.code === DEVELOPER_HEADQUARTERS));
    }
    return false;
  }
  checkAccess = (statusID) => {
    switch (statusID) {
      case '100':
      case '502':
        return true;
      default:
        return false;
    }
  }
  passwordValidation = () => ({
    validRegex: '^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$',
  })
  userStateses = [
    { value: '100', text: 'Active' },
    // { value: '502', text: 'Delist' },
    { value: '503', text: 'Suspend' },
  ]
  renderUserBookingCooldown = (data) => {
    const { t, auth } = this.props;
    const countryCode = auth && auth.company && auth.company.countryCode;
    const zoneFormat = cooldownFormat(countryCode);
    if (data && data.length > 0) {
      return data.map((row, idx) => (
        <Table.Row key={idx}>
          <Table.Cell>
            <Link to={`/projects/${row.projectID}/units/${row.projectUnitID}/`}>{row.projectUnitReference}, {row.projectShortName}</Link>
          </Table.Cell>
          <Table.Cell>
            {displayMoment(row.cooldownStartAt, countryCode).format(zoneFormat)}
          </Table.Cell>
          <Table.Cell>
            {displayMoment(row.cooldownEndAt, countryCode).format(zoneFormat)}
          </Table.Cell>
          <Table.Cell>
            <Button
              negative
              type="button"
              size="small"
              icon="trash"
              onClick={e => this.handleDeleteCooldownOpen(e, row.id, `${row.projectUnitReference}, ${row.projectShortName}`, 'unit')}
            />
          </Table.Cell>
        </Table.Row>
      ));
    }
    return (
      <Table.Row>
        <Table.Cell colSpan="4" textAlign="center">
          <Segment textAlign="center" vertical>
            <p>{t('No cooldown found', { ns: TRANSLATION_FILES.translation })}.</p>
          </Segment>
        </Table.Cell>
      </Table.Row>
    );
  }
  renderUserBookingCooldowns(data) {
    const { t } = this.props;
    return (
      <Table celled unstackable structured>
        {(data && data.length > 0) ?
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Unit, Project', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Started At', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Expires At', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" collapsing ><Icon fitted name="setting" /></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          : null}
        <Table.Body>
          {this.renderUserBookingCooldown(data)}
        </Table.Body>
      </Table>
    );
  }
  renderUserBAPBan = (data) => {
    const { t, auth } = this.props;
    const countryCode = auth && auth.company && auth.company.countryCode;
    const zoneFormat = cooldownFormat(countryCode);
    if (data && data.length > 0) {
      return data.map((row, idx) => (
        <Table.Row key={idx} error={row.attemptsCount >= row.project.bapMaxAttempts || false}>
          <Table.Cell>
            {row.isProjectMode
              ? <Link to={`/projects/${row.projectID}/`}>{row.projectShortName} <small>({row.projectUnitReference})</small></Link>
              : <Link to={`/projects/${row.projectID}/units/${row.projectUnitID}/`}>{row.projectShortName}, {row.projectUnitReference}</Link>
            }
          </Table.Cell>
          <Table.Cell textAlign="center">
            {row.isProjectMode ? <Icon name="checkmark" color="green" /> : <Icon name="close" color="grey" />}
          </Table.Cell>
          <Table.Cell>
            {row.attemptsCount}
          </Table.Cell>
          <Table.Cell>
            <small>{displayMoment(row.previousAttempt, countryCode).format(zoneFormat)}</small>
          </Table.Cell>
          <Table.Cell>
            <small>{displayMoment(row.latestAttempt, countryCode).format(zoneFormat)}</small>
          </Table.Cell>
          <Table.Cell>
            <small>{(row.attemptsCount >= row.project.bapMaxAttempts) ? displayMoment(row.latestAttempt, countryCode).add(row.project.bapCooldownMinutes, 'minutes').format(zoneFormat) : '-'}</small>
          </Table.Cell>
          <Table.Cell>
            <Button
              negative
              type="button"
              size="small"
              icon="trash"
              onClick={e => this.handleDeleteCooldownOpen(e, row.id, `${row.projectUnitReference}, ${row.projectShortName}`, 'bap')}
            />
          </Table.Cell>
        </Table.Row>
      ));
    }
    return (
      <Table.Row>
        <Table.Cell colSpan="4" textAlign="center">
          <Segment textAlign="center" vertical>
            <p>{t('No entries found', { ns: TRANSLATION_FILES.translation })}.</p>
          </Segment>
        </Table.Cell>
      </Table.Row>
    );
  }
  renderUserBAPBans(data) {
    const { t } = this.props;
    return (
      <Table celled unstackable structured>
        {(data && data.length > 0) ?
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Project / Unit', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Project-Wide Ban', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Attempts', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Previous Attempt At', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Latest Attempt At', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell>{t('Ban Expires At', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" collapsing ><Icon fitted name="setting" /></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          : null}
        <Table.Body>
          {this.renderUserBAPBan(data)}
        </Table.Body>
      </Table>
    );
  }
  checkDisabledGroup(code) {
    switch (code) {
      case COMMISSION_TRACKER_TEAM_LEADER:
      case COMMISSION_TRACKER_AGENT:
        return !this.state.selectedBranchIsExternal;
      default:
        return this.state.selectedBranchIsExternal;
    }
  }
  render() {
    const { t } = this.props;
    const { data, cooldownBAPData, cooldownData, showDeleteCooldownConfirm, deleteCooldownName, selectedBranchIsExternal } = this.state;
    const { auth } = this.props;
    const ROLES = roleOptions(selectedBranchIsExternal);
    // Nobody may change their own Access Role, so the Select below is disabled on
    // your own record. Do not require it in that case too, or a self-edit of an
    // unrelated field is blocked by a control you are not allowed to touch.
    // Guard on a truthy email as well: two missing emails compare equal, which
    // would silently disable the field on somebody else's record.
    // `data` is null until fetchStaff resolves, so guard it — render runs first.
    const isOwnRecord = !!data && !!auth && !!auth.email && auth.email === data.email;

    const links = routes(this.props.routeParams.id);
    const { pathname } = this.props.location;
    const tinContent = (data && data.taxIdentificationNo) || this.state.tinRequired;

    const isMalaysia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'MY';
    const isIndonesia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'ID';

    let tinValidation = [];
    if (isIndonesia) {
      tinValidation = [
        {
          validate: matchRegex,
          option: { validRegex: REGEX_NPWP_ID },
        },
      ];
    } else if (isMalaysia) {
      tinValidation = [
        {
          validate: matchRegex,
          option: { validRegex: REGEX_TIN_VALID },
        },
      ];
    }
    return (
      <Container>
        <MoveStaffToExternalBranch
          open={this.state.showConfirmBranch}
          onClose={this.handleCancelChange}
          onConfirm={this.handleConfirmChange}
          staffpreferredName={this.state.data ? this.state.data.preferredName : ''}
        />
        <DeleteConfirm
          content={t(`Are you sure you want to delete the ${this.state.deleteCooldownType === 'bap' ? 'entry' : 'cooldown'} for {{name}}?`, { ns: TRANSLATION_FILES.translation, name: deleteCooldownName })}
          onClose={this.handleCancelDeleteCooldown}
          onConfirm={this.handleConfirmDeleteCooldown}
          open={showDeleteCooldownConfirm}
        />
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
        />
        <ProjectsList
          open={this.state.showAddProject}
          onClose={this.handleCloseAddProject}
          onConfirm={this.handleAddProject}
          onCheck={project => project.loanTrackerProjectID < 1}
          selected={data ? data.projects : []}
          userBranchProjects={!this.getBranchViewAllProjects() ? this.getBranchProjects() : []}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Dimmer active={this.state.loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Divider horizontal>{t('User Information')}</Divider>
              {data ?
                <EditableBox
                  editable={
                    !(this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) ?
                    !this.isEditStaffHeadquarters() :
                    true
                  }
                  isEditing={this.state.edit}
                  loading={this.state.loading}
                  onEdit={this.handleEditStaff}
                  onClick={this.handleUpdateStaff}
                  onCancel={this.handleResetChanges}
                  content={({ isEditing, onConfirm }) => (
                    <Grid>
                      <Grid.Row>
                        <Dimmer active={this.state.isEditing} inverted />
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                          {
                            this.state.oriData ?
                              <Grid>
                                <Grid.Row stretched>
                                  <Grid.Column width={16}>
                                    <Header as="h2" textAlign="center">
                                      {this.state.oriData.preferredName}
                                      {
                                        this.props.auth.email === this.state.oriData.email ?
                                          <Label size="small" pointing="left">You</Label> : ''
                                      }
                                      {
                                        this.state.oriData.companyBranch ?
                                          <Header.Subheader>
                                            <i>{this.state.oriData.companyBranch.name}</i>
                                          </Header.Subheader> :
                                        null
                                      }
                                      <Header.Subheader>
                                        <i><Timestamp format="MMMM Do YYYY, h:mm a" timestamp={this.state.oriData.createdAt} /></i>
                                      </Header.Subheader>
                                    </Header>
                                  </Grid.Column>
                                  <Grid.Column width={16}>
                                    <Divider hidden className="tablet-hide" />
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid> :
                            null
                          }
                          <Divider hidden className="large-hide small-hide" />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <AppForm
                            onSubmit={onConfirm}
                            error={this.state.errMessages.length > 0}
                            ref={(ref) => { this.form = ref; }}
                          >
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'name', 'user')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="name"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'name', 'user')}
                                      value={data.name}
                                      ref={this.validation.name}
                                      validateLabel={translateModels(t, 'name', 'user')}
                                      validation={[required]}
                                    /> :
                                    data.name
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'preferredName', 'user')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="preferredName"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'preferredName', 'user')}
                                      value={data.preferredName}
                                      ref={this.validation.preferredName}
                                      validation={[required]}
                                      validateLabel={translateModels(t, 'preferredName', 'user')}
                                    /> :
                                    data.preferredName
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={4}>
                                <b>{translateModels(t, 'mobile', 'user')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={12}>
                                {
                                  isEditing ?
                                    <Grid className="compact">
                                      <Grid.Column width={16}>
                                        <Select
                                          validation={[required]}
                                          ref={this.validation.mobilePrefix}
                                          onChange={this.handleOnChange}
                                          name="mobilePrefix"
                                          options={INTL_CALL_CODES}
                                          selectOnBlur={false}
                                          value={data.mobilePrefix}
                                        />
                                      </Grid.Column>
                                      <Grid.Column width={16}>
                                        <PhoneInput
                                          fluid
                                          name="mobile"
                                          onChange={this.handleOnChange}
                                          type="tel"
                                          placeholder={t('Mobile')}
                                          prefix={data.mobilePrefix}
                                          value={data.mobile}
                                          validation={[required, {
                                            validate: phoneNumber,
                                            option: data.mobilePrefix === 'other' ? {} : {
                                              isMobile: true,
                                              phonePrefix: data.mobilePrefix,
                                              validRegex: getPhoneValidRegex(
                                                this.state.phoneValidationPresets,
                                                data.mobilePrefix,
                                                'mobile',
                                              ),
                                            },
                                          }]}
                                          validateLabel={translateModels(t, 'mobile', 'user')}
                                          ref={this.validation.mobile}
                                        />
                                      </Grid.Column>
                                    </Grid>
                                : <Phone
                                  mobilePrefix={data.mobilePrefix}
                                  mobile={data.mobile}
                                />
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={4}>
                                <b>{translateModels(t, 'officeTel', 'user')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={12}>
                                {
                                  isEditing ?
                                    <Grid className="compact">
                                      <Grid.Column width={16}>
                                        <Form.Select
                                          fluid
                                          search
                                          name="officeTelPrefix"
                                          onChange={this.handleOnChange}
                                          options={INTL_CALL_CODES}
                                          selectOnBlur={false}
                                          value={data.officeTelPrefix}
                                          noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                        />
                                      </Grid.Column>
                                      <Grid.Column width={16}>
                                        <PhoneInput
                                          fluid
                                          name="officeTel"
                                          onChange={this.handleOnChange}
                                          prefix={data.officeTelPrefix}
                                          type="tel"
                                          placeholder={translateModels(t, 'officeTel', 'user')}
                                          value={data.officeTel}
                                          validation={[{
                                            validate: phoneNumber,
                                            option: data.officeTelPrefix === 'other' ? {} : {
                                              phonePrefix: data.officeTelPrefix,
                                              validRegex: getPhoneValidRegex(
                                                this.state.phoneValidationPresets,
                                                data.officeTelPrefix,
                                                'phone',
                                              ),
                                            },
                                          }]}
                                        />
                                      </Grid.Column>
                                    </Grid>
                                : <Phone
                                  mobilePrefix={data.officeTelPrefix}
                                  mobile={data.officeTel}
                                />
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'email', 'user')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="email"
                                      onChange={this.handleOnChange}
                                      type="email"
                                      placeholder={translateModels(t, 'email', 'user')}
                                      value={data.email}
                                      ref={this.validation.email}
                                      validation={[required]}
                                      validateLabel={translateModels(t, 'email', 'user')}
                                      disabled={!!data.user.awsUsername}
                                    /> :
                                    <a href={`mailto:${data.email}`}>
                                      {data.email}
                                    </a>
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'userID', 'user')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8} title={`MHub User ID (Affiliate ID: ${data.id})`}>
                                {data.userID}
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={8}>
                                <b>{translateModels(t, 'fullName', 'user')} {isMalaysia && t('(as in MyKad)')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={8}>
                                {
                                  isEditing ?
                                    <AppForm.Input
                                      fluid
                                      name="fullName"
                                      onChange={this.handleOnChange}
                                      placeholder={translateModels(t, 'fullName', 'user')}
                                      value={data.fullName}
                                      ref={this.validation.fullName}
                                      validateLabel={translateModels(t, 'fullName', 'user')}
                                      validation={
                                        (data.bankAccountName && data.bankAccountNumber) ?
                                          [required, { validate: matchRegex, option: { validRegex: REGEX_FULL_NAME } }] :
                                          [{ validate: matchRegex, option: { validRegex: REGEX_FULL_NAME } }]
                                      }
                                    /> :
                                    data.fullName ? data.fullName : '-'
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={6}>
                                <b>{isMalaysia ? 'MyKad (NRIC)' : isIndonesia ? 'KTP' : t('Identity Number')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                {
                                  isEditing ?
                                    isMalaysia ? (
                                      <AppForm.Input
                                        fluid
                                        name="identityNo"
                                        validateLabel="MyKad (NRIC)"
                                        required={tinContent}
                                        onChange={this.handleOnChange}
                                        placeholder="MyKad (NRIC)"
                                        value={data.identityNo}
                                        validation={tinContent ?
                                        [required,
                                          {
                                            validate: ValidateIdentity,
                                            option: {
                                              countryCode: 'MY',
                                              identityType: 'ic_number',
                                            },
                                          },
                                        ] :
                                        [{
                                          validate: ValidateIdentity,
                                          option: {
                                            countryCode: 'MY',
                                            identityType: 'ic_number',
                                          },
                                        }]}
                                        ref={this.validation.identityNo}
                                        type="text"
                                      />
                                    ) :
                                      isIndonesia && (
                                        <AppForm.Input
                                          fluid
                                          name="identityNo"
                                          validateLabel="KTP"
                                          required={tinContent}
                                          onChange={this.handleOnChange}
                                          placeholder="KTP"
                                          value={data.identityNo}
                                          validation={tinContent ?
                                          [required,
                                            {
                                              validate: matchRegex,
                                              option: { validRegex: /^[a-zA-Z0-9_]*$/ },
                                            },
                                          ] :
                                          [{
                                            validate: matchRegex,
                                            option: { validRegex: /^[a-zA-Z0-9_]*$/ },
                                          }]}
                                          ref={this.validation.identityNo}
                                          type="text"
                                        />
                                      )
                                    :
                                    data.identityNo ? data.identityNo : '-'
                                }
                              </Grid.Column>
                            </Grid>
                            <Divider style={styles.divider} />
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                              {
                                isEditing && (isMalaysia || isIndonesia) ?
                                  <Grid verticalAlign="middle">
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>
                                        {isMalaysia && 'Tax Identification Number (TIN)'}
                                        {isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'}
                                      </b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      <TinFieldInput
                                        isIndonesia={isIndonesia}
                                        hideLabel
                                        value={data.taxIdentificationNo}
                                        errMessage={this.state.tinMessage}
                                        isLoading={this.state.validatingTin}
                                        tinError={isMalaysia && this.state.tinError}
                                        ref={this.validation.taxIdentificationNo}
                                        onChange={this.handleTinInput}
                                        required={this.state.tinRequired}
                                        // readOnly={isMalaysia && (this.state.tinFound || !this.state.tinEnabled)}
                                        validation={tinValidation}
                                        identityType={IDENTITY_TYPE_NRIC}
                                        identityValue={data.identityNo}
                                      />
                                    </Grid.Column>
                                  </Grid> :
                                  <Grid>
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>
                                        {isMalaysia && 'Tax Identification Number (TIN)'}
                                        {isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'}
                                      </b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        {data && data.taxIdentificationNo ? (
                                          <div>
                                            {isMalaysia && (
                                              <Icon
                                                name={data.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle'}
                                                color={data.taxTinValidationStatus === 'success' ? 'green' : 'red'}
                                                style={{ marginLeft: '0.5em' }}
                                              />
                                            )}
                                            <i>{data.taxIdentificationNo}</i>
                                          </div>
                                        ) : (
                                          '-'
                                        )}
                                      </span>
                                    </Grid.Column>
                                  </Grid>
                              }
                            </Grid.Column>
                            <Divider style={styles.divider} />
                            {isEditing ?
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'bankAccountName', 'user')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    <SelectBank
                                      country={auth && auth.company ? auth.company.countryCode : ''}
                                      validateLabel={translateModels(t, 'bankAccountName', 'user')}
                                      ref={this.validation.bankAccountName}
                                      onChange={this.handleOnChange}
                                      name="bankAccountName"
                                      placeholder={t('Select {{title}}', { title: t('Bank') })}
                                      value={data.bankAccountName}
                                      validation={data.bankAccountNumber ? [required] : []}
                                    />
                                  </Grid.Column>
                                </Grid>
                              </Grid.Column> :
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'bankAccountName', 'user')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {data.bankAccountName || '-'}
                                  </Grid.Column>
                                </Grid>
                              </Grid.Column>
                            }
                            <Divider style={styles.divider} />
                            {isEditing ?
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'bankAccountNumber', 'user')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    <AppForm.Input
                                      fluid
                                      name="bankAccountNumber"
                                      validateLabel={t('Bank Account Number')}
                                      onChange={this.handleOnChange}
                                      placeholder="E.g. 231466322123"
                                      value={data.bankAccountNumber}
                                      ref={this.validation.bankAccountNumber}
                                      type="text"
                                      validation={data.bankAccountName ?
                                        [required, { validate: matchRegex, option: { validRegex: REGEX_BANK_ACCOUNT_NUMBER } }] :
                                        [{ validate: matchRegex, option: { validRegex: REGEX_BANK_ACCOUNT_NUMBER } }]
                                      }
                                    />
                                  </Grid.Column>
                                </Grid>
                              </Grid.Column> :
                              <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Grid>
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{translateModels(t, 'bankAccountNumber', 'user')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {data.bankAccountNumber || '-'}
                                  </Grid.Column>
                                </Grid>
                              </Grid.Column>
                            }
                          </AppForm>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <AppForm
                            onSubmit={onConfirm}
                            error={this.state.errMessages.length > 0}
                            ref={(ref) => { this.form = ref; }}
                          >
                            {
                              (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin)
                              && data.companyBranch ?
                                <div>
                                  <Grid verticalAlign="middle">
                                    <Grid.Column textAlign="left" width={6}>
                                      <b>{t('Business Unit')}</b>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right" width={10}>
                                      {
                                        isEditing ?
                                          <Select
                                            validation={[required]}
                                            ref={this.validation.companyBranchID}
                                            onChange={this.handleOnChange}
                                            name="companyBranchID"
                                            text={data.companyBranchID ? null : t('Select business unit')}
                                            value={data.companyBranchID}
                                            options={this.state.branches}
                                            disabled={this.state.branches.length === 0}
                                          /> :
                                          (this.props.auth.isSuperAdmin ||
                                            this.props.auth.isHeadquarters) ?
                                            data.companyBranch ?
                                              <Link to={`/business_units/${data.companyBranchID}/`}>
                                                {data.companyBranch.name}
                                                {
                                                  data.companyBranch.isExternal ?
                                                    <Label size="mini" pointing="left" color="teal">{t('Agency')}</Label> : ''
                                                }
                                              </Link>
                                              : ''
                                            :
                                            data.companyBranch ? data.companyBranch.name : ''
                                      }
                                    </Grid.Column>
                                  </Grid>
                                </div> :
                              null
                            }
                            {(this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin)
                              && data.companyBranch ?
                                <Divider style={styles.divider} />
                              : null
                            }
                            <Grid verticalAlign="middle">
                              <Grid.Column textAlign="left" width={6}>
                                <b>{t('Access Role')}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={10}>
                                { isEditing ?
                                  <Select
                                    name="role"
                                    validation={isOwnRecord ? [] : [required]}
                                    validateLabel={t('Access Role')}
                                    ref={this.validation.role}
                                    value={this.getRoles()}
                                    onChange={this.handleChangeRole}
                                    options={ROLES.map(role => ({
                                      ...role,
                                      text: t(role.text, { ns: TRANSLATION_FILES.constants }),
                                    }))}
                                    disabled={isOwnRecord}
                                  />
                                  : t(this.getRoleText(ROLES), { ns: TRANSLATION_FILES.constants })
                                }
                              </Grid.Column>
                            </Grid>
                          </AppForm>
                          <Divider style={styles.divider} />
                          <Form
                            onSubmit={onConfirm}
                          >
                            {
                              auth && data.user &&
                              (auth.isHeadquarters || auth.isSuperAdmin ||
                              auth.isBranchLeaderSupervisor) ?
                                <Grid verticalAlign="top">
                                  <Grid.Column textAlign="left" width={6}>
                                    <b>{t('Access')}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={10}>
                                    {
                                      auth.id !== data.user.id && (isEditing ?
                                        <div>
                                          <Form.Select
                                            fluid
                                            name="statusID"
                                            onChange={this.handleUserOnChange}
                                            options={this.userStateses.map(status => ({
                                              ...status,
                                              text: t(status.text, { ns: TRANSLATION_FILES.constants }),
                                            }))}
                                            selectOnBlur={false}
                                            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                            value={data.user.statusID}
                                          />
                                          <Form.Checkbox
                                            checked={this.checkAccess(data.user.statusID)}
                                            label={t('Has access', { ns: TRANSLATION_FILES.constants })}
                                            name="hasAccess"
                                            onChange={this.handleUserCheckBoxChange}
                                            disabled
                                          />
                                        </div> :
                                        this.accessStatus(data.user.statusID))
                                    }
                                    {
                                      data.access && ((auth.isHeadquarters && auth.isMainHeadquarters) || auth.isSuperAdmin) &&
                                      data.user && data.user.groups &&
                                      data.user.groups.some(g => g.code === DEVELOPER_HEADQUARTERS ||
                                      g.code === DEVELOPER_BRANCH_LEADER || g.code === DEVELOPER_BRANCH_LEADER_SUPERVISOR ||
                                      g.code === DEVELOPER_BRANCH_LEADER_SUPERVISOR_II) ? (
                                        <div>
                                          <Form.Checkbox
                                            checked={data.access.allowEditUnitPrice}
                                            label={t("Allow to edit unit's price", { ns: TRANSLATION_FILES.translation })}
                                            name="allowEditUnitPrice"
                                            onChange={this.handleAccessCheckBoxChange}
                                            disabled={!isEditing}
                                          />
                                          <Form.Checkbox
                                            checked={data.access.allowEditUnitDetails}
                                            label={t("Allow to edit unit's details", { ns: TRANSLATION_FILES.translation })}
                                            name="allowEditUnitDetails"
                                            onChange={this.handleAccessCheckBoxChange}
                                            disabled={!isEditing}
                                          />
                                        </div>
                                      ) : null
                                    }
                                  </Grid.Column>
                                </Grid>
                                : ''
                            }
                            {
                              isEditing && auth && data.user && auth.id !== data.user.id &&
                              (auth.isHeadquarters || auth.isSuperAdmin ||
                              auth.isBranchLeaderSupervisor) ?
                                <Divider style={styles.divider} />
                                : null
                            }
                            <Grid verticalAlign="middle">
                              {
                                (isEditing && (auth.isHeadquarters || auth.isMainHeadquarters || auth.isSuperAdmin)) ?
                                  <Grid.Column textAlign="left" width={16}>
                                    <AppForm.Input
                                      fluid
                                      label={t('New Password Update')}
                                      placeholder={t('Minimum 6 characters with 1 uppercase, 1 lowercase and 1 number required.')}
                                      name="updatePassword"
                                      type="password"
                                      onChange={this.handleUserOnChange}
                                      validation={[required, {
                                        validate: matchRegex,
                                        option: this.passwordValidation(),
                                      }]}
                                    />
                                  </Grid.Column> :
                                  null
                              }
                              <Grid.Column textAlign="right" width={16} style={data.user.awsUsername || (!isEditing && !data.user.awsUsername) ? { paddingTop: '0' } : null}>
                                <Form.Checkbox
                                  checked={data.user.passwordUpdateRequired}
                                  label={t('Require password update next login')}
                                  name="passwordUpdateRequired"
                                  onChange={this.handleUserCheckBoxChange}
                                  disabled={!isEditing || !!(data.user.awsUsername && data.user.awsUsername.includes(data.user.email))}
                                />
                              </Grid.Column>
                            </Grid>
                          </Form>
                          {this.props.auth.isSuperAdmin && <Divider style={styles.divider} />}
                          {
                            this.props.auth.isSuperAdmin ?
                              <Form
                                onSubmit={onConfirm}
                              >
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={5}>
                                    <b>{t('Group Access', { ns: TRANSLATION_FILES.translation })}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={11}>
                                    {devGroups.map((group, idx) => (
                                      <Form.Checkbox
                                        checked={this.isUserType(group.id)}
                                        key={idx}
                                        label={t(group.name, { ns: TRANSLATION_FILES.constants })}
                                        value={group.code}
                                        name={group.code}
                                        disabled={!isEditing}
                                      />
                                      ))
                                    }
                                  </Grid.Column>
                                </Grid>
                              </Form> :
                              null
                          }
                          {(this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) && !selectedBranchIsExternal && <Divider style={styles.divider} />}
                          {
                            (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) && !selectedBranchIsExternal ?
                              <Form
                                onSubmit={onConfirm}
                              >
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={5}>
                                    <b>{t('Credit Control Access', { ns: TRANSLATION_FILES.translation })}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={11}>
                                    {creditControlGroups.map((group, idx) => (
                                      <Form.Checkbox
                                        checked={this.isUserType(group.id)}
                                        key={idx}
                                        label={t(group.name, { ns: TRANSLATION_FILES.constants })}
                                        value={group.code}
                                        name={group.code}
                                        disabled={!isEditing}
                                        onChange={(e, d) => this.handleGroupChange(e, d, creditControlGroups)}
                                      />
                                      ))
                                    }
                                  </Grid.Column>
                                </Grid>
                              </Form> :
                              null
                          }
                          {(this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) && <Divider style={styles.divider} />}
                          {
                            this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin ?
                              <Form
                                onSubmit={onConfirm}
                              >
                                <Grid verticalAlign="middle">
                                  <Grid.Column textAlign="left" width={5}>
                                    <b>{t('Commission Tracker Access', { ns: TRANSLATION_FILES.translation })}</b>
                                  </Grid.Column>
                                  <Grid.Column textAlign="right" width={11}>
                                    {commissionTrackerGroups.map((group, idx) => (
                                      <Form.Checkbox
                                        checked={this.isUserType(group.id)}
                                        key={idx}
                                        label={t(group.name, { ns: TRANSLATION_FILES.constants })}
                                        value={group.code}
                                        name={group.code}
                                        disabled={!isEditing || this.checkDisabledGroup(group.code)}
                                        onChange={(e, d) => this.handleGroupChange(e, d, commissionTrackerGroups)}
                                      />
                                      ))
                                    }
                                  </Grid.Column>
                                </Grid>
                              </Form> :
                              null
                          }
                          <Form
                            onSubmit={onConfirm}
                          >
                            <Divider style={styles.divider} />
                            <Grid>
                              <Grid.Column textAlign="left" width={4}>
                                <b>{t('Projects Access', { ns: TRANSLATION_FILES.screens })}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={12}>
                                {this.getBranchViewAllProjects() ?
                                    t('All Projects (Set by Business Unit)', { ns: TRANSLATION_FILES.screens })
                                  :
                                    <Form.Checkbox
                                      checked={data.viewAllProjects}
                                      label={t('View all projects', { ns: TRANSLATION_FILES.screens })}
                                      name="viewAllProjects"
                                      onChange={this.handleCheckBoxChange}
                                      disabled={!isEditing}
                                    />
                                }
                              </Grid.Column>
                            </Grid>
                            <Grid>
                              <Grid.Column textAlign="left" width={4}>
                                <b>{t('Analytics Access', { ns: TRANSLATION_FILES.screens })}</b>
                              </Grid.Column>
                              <Grid.Column textAlign="right" width={12}>
                                <Form.Checkbox
                                  checked={data.user && data.user.groups && data.user.groups && data.user.groups.findIndex(g => g.id === GROUP_ID_ANALYTICS) !== -1}
                                  label={t('View analytics dashboard', { ns: TRANSLATION_FILES.screens })}
                                  name="viewAnalyticsDashboard"
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!isEditing}
                                />
                              </Grid.Column>
                            </Grid>
                          </Form>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    )}
                />
                  : <Grid>
                    {this.state.loading ? '' : t('No staff found', { ns: TRANSLATION_FILES.screens })}
                  </Grid>
              }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {
                !this.state.loading && (
                  <SpecificationTable
                    type="affiliateMappings"
                    editable
                    isEditing={this.state.edit}
                    hideButton
                    notFoundNode={<p>{t('No mapping set')}</p>}
                    headerNode={t('User API Mapping')}
                    data={data && data.mappings ? data.mappings : []}
                    onChange={this.handleMappingChange}
                    loading={this.state.loading}
                  />
                )
              }
            </Grid.Column>
          </Grid.Row>
          {
            data && !data.viewAllProjects && !this.getBranchViewAllProjects() ? (
              <Grid.Row>
                <Grid.Column>
                  <Divider horizontal>{t('Projects Access')}</Divider>
                  <Table unstackable>
                    <Table.Body>
                      { !this.getBranchViewAllProjects() && this.getBranchProjects().length > 0 ?
                        this.getBranchProjects().map((project, idx) => (
                          <Table.Row key={idx}>
                            <Table.Cell>
                              <ListItem
                                item={project}
                                header={item => <span>{item.name} <Icon name="eye" fitted /><i> <small>{t('Business Unit Access')}</small></i></span>}
                                subheader={item => item.status.name}
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))
                        : null
                      }
                      { data.projects && data.projects.length > 0 &&
                        data.projects.map((project, idx) => (
                          <Table.Row key={idx}>
                            <Table.Cell>
                              <ListItem
                                item={project}
                                header={item => item.name}
                                subheader={item => item.status.name}
                                rightComponent={
                                  <div className={this.state.edit ? null : 'hidden'}>
                                    <Button
                                      type="button"
                                      compact
                                      negative
                                      size="mini"
                                      icon="remove"
                                      onClick={() => this.handleRemoveProject(idx)}
                                      disabled={!this.state.edit}
                                    />
                                  </div>
                                }
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))
                      }
                    </Table.Body>
                  </Table>
                  { !((data.projects && data.projects.length > 0) ||
                    (this.getBranchProjects() && this.getBranchProjects().length > 0)
                  ) &&
                    <Segment textAlign="center">
                      {
                        this.state.loading ?
                          <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                        : t('No projects access', { ns: TRANSLATION_FILES.screens })
                      }
                    </Segment>
                  }
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
          {
            (data &&
              !data.viewAllProjects &&
              !this.getBranchViewAllProjects()
            ) && this.state.edit ? (
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <Button
                    content={t('Add project', { ns: TRANSLATION_FILES.screens })}
                    onClick={this.handleShowAddProject}
                  />
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
          {this.staffIsAgent() ?
            (
              <Grid.Row>
                <Grid.Column>
                  <Dimmer active={this.state.loading} inverted>
                    <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                  </Dimmer>
                  <Divider horizontal>{t('User Booking Cooldown', { ns: TRANSLATION_FILES.translation })}</Divider>
                  {this.renderUserBookingCooldowns(cooldownData)}
                </Grid.Column>
              </Grid.Row>
            )
            : ''
          }
          {this.staffIsAgent() ?
            (
              <Grid.Row>
                <Grid.Column>
                  <Dimmer active={this.state.loading} inverted>
                    <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                  </Dimmer>
                  <Divider horizontal>{t('User Booking Abuse Prevention', { ns: TRANSLATION_FILES.translation })}</Divider>
                  {this.renderUserBAPBans(cooldownBAPData)}
                </Grid.Column>
              </Grid.Row>
            )
            : ''
          }
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.user,
], { withRef: true })(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Staffs/Overview.jsx